import React from "react";
import { Link } from "react-router-dom";
import { AcademicCapIcon } from "@heroicons/react/24/outline";
import styles from "./HeaderQBankLink.module.css";

interface HeaderQBankLinkProps {
  className?: string;
  isActive?: boolean;
  label?: string;
  to?: string;
}

const HeaderQBankLink: React.FC<HeaderQBankLinkProps> = ({
  className = "",
  isActive = false,
  label = "SDLE QBank",
  to = "/qbank/sdle",
}) => {
  const classes = [
    styles.qbankLink,
    isActive ? styles.qbankLinkActive : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <Link to={to} className={classes} aria-current={isActive ? "page" : undefined}>
      <AcademicCapIcon className={styles.qbankIcon} aria-hidden="true" />
      <span>{label}</span>
    </Link>
  );
};

export default HeaderQBankLink;
